'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NoPage = function (_React$Component) {
  _inherits(NoPage, _React$Component);

  function NoPage() {
    _classCallCheck(this, NoPage);

    return _possibleConstructorReturn(this, (NoPage.__proto__ || Object.getPrototypeOf(NoPage)).apply(this, arguments));
  }

  _createClass(NoPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          style: {
            position: 'absolute',
            textAlign: 'center',
            top: '50%',
            marginTop: '-300px',
            left: '50%',
            marginLeft: '-175px'
          }
        },
        _react2.default.createElement(
          'h1',
          {
            style: {
              fontSize: '13rem',
              fontWeight: 700,
              height: '58px',
              textShadow: '0px 3px 0px # 7 f8c8d'
            }
          },
          '404'
        ),
        _react2.default.createElement(
          'div',
          {
            style: {
              lineHeight: '60px'
            }
          },
          'ERROR'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/' },
            '\u8FD4\u56DE\u4E3B\u9875'
          )
        )
      );
    }
  }]);

  return NoPage;
}(_react2.default.Component);

exports.default = NoPage;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-router-controller/libs/DefaultNotMatchComponent/index.js
// module id = 1224
// module chunks = 0